import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";
import App from './App.tsx'
import './index.css'
import { AuthProvider } from './AuthProvider.tsx'

// Initialize Sentry before rendering the app
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: "https://645014ff012101cb50f94da05ac32125@o4509447870873600.ingest.de.sentry.io/4509447888830544",
    environment: import.meta.env.MODE || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0, // 10% in production
    // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost", 
      /^https:\/\/beyondpages\.io\/api/,
      /^https:\/\/app\.beyondpages\.io\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors will be recorded
  });
  console.log('🔍 Sentry initialized for error tracking');
} else {
  console.log('⚠️  Sentry DSN not found - error tracking disabled');
}

// Check for magic link parameters before rendering the app
const params = new URLSearchParams(window.location.search)
const token_hash = params.get('token_hash')
const type = params.get('type')

// If we have magic link parameters and we're at the root path, redirect
if (token_hash && type === 'email' && window.location.pathname === '/') {
  console.log('🔐 Magic link detected in main.tsx! Redirecting to /auth/confirm...')
  window.location.href = '/auth/confirm' + window.location.search
} else {
  // Only render the app if we're not redirecting
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={({ error }: { error: Error }) => (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Ein Fehler ist aufgetreten</h1>
            <p className="text-gray-600 mb-4">Bitte laden Sie die Seite neu oder kontaktieren Sie den Support.</p>
            {import.meta.env.DEV && (
              <pre className="text-left text-xs bg-gray-100 p-4 rounded overflow-auto">
                {error.toString()}
              </pre>
            )}
          </div>
        </div>
      )} showDialog>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Sentry.ErrorBoundary>
    </React.StrictMode>,
  )
}
